import React from "react";
import moment from "moment";
import { InvoiceFragment } from "@graphql";
import { Button, Typography } from "@material-ui/core";
import { OpenInNewRounded } from "@material-ui/icons";
import { InboxArrowDown, InboxArrowUp } from "mdi-material-ui";
import locale from "@bonliva-crm/locale";
import { useTheme } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

type Props = {
  data: InvoiceFragment;
  onOpen?: () => void;
};

export function InvoiceCard(props: Props) {
  const { data } = props;
  const theme = useTheme<ThemeType>();

  if (!data) {
    return null;
  }

  const iconStyle = { marginRight: 16 };

  const icon = data.IsCredit ? (
    <InboxArrowUp style={{ ...iconStyle, color: theme.palette.error.main }} />
  ) : (
    <InboxArrowDown style={{ ...iconStyle, color: theme.palette.success.main }} />
  );

  const details = [];
  details.push(`#${data.InvoiceNumber}`);
  details.push(`${locale.CustomerNumberShort}: ${data.CustomerNumber}`);
  details.push(`${locale.Total}: ${data.TotalNet} kr.`);

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {icon}

      <Typography>
        <span style={{ fontWeight: "bold", display: "block" }}>{data.CustomerName}</span>
        <span style={{ display: "block" }}>{details.join(", ")}</span>
        {data.DueDate && (
          <span style={{ display: "block" }}>
            {locale.DueDate}: {moment.utc(data.DueDate).format("L")}
          </span>
        )}
      </Typography>

      {props.onOpen && (
        <Button
          onClick={(e) => {
            props.onOpen();
            e.stopPropagation();
          }}
          style={{ flex: 1 }}
        >
          <OpenInNewRounded style={{ marginRight: 8 }} />
          View
        </Button>
      )}
    </div>
  );
}
